(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tutorial-preview"] && !Shopify.designMode) return;
  try {
    
(function () {
  var modal    = document.getElementById('mgTpModal');
  var iframe   = document.getElementById('mgTpIframe');
  var titleEl  = document.getElementById('mgTpModalTitle');
  var closeBtn = document.getElementById('mgTpModalClose');

  if (!modal || !iframe) return;

  function openModal(videoId, videoTitle) {
    titleEl.textContent = videoTitle || '';
    iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&modestbranding=1';
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-open');
    iframe.src = '';
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.mg-tp__card:not(.mg-tp__card--ghost)').forEach(function (card) {
    function handleOpen() {
      var id    = card.dataset.videoId;
      var title = card.dataset.videoTitle;
      if (!id) return;
      openModal(id, title);
    }
    card.addEventListener('click', handleOpen);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleOpen();
      }
    });
  });

  closeBtn && closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
